export { BackgroundImageSection } from './BackgroundImageSection';
